import React from 'react';
import { Accordion } from '@/components/ui/Accordion';
import { faqItems } from '@/data/faq';
import { useScrollReveal } from '@/lib/useScrollReveal';

export const FAQ: React.FC = () => {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  const accordionItems = faqItems.map((item) => ({
    id: item.id,
    question: item.question,
    answer: item.answer,
  }));

  return (
    <section className="py-20 bg-surface-secondary" ref={ref}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className={`text-center mb-16 transition-all duration-500 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-text-primary mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-text-secondary">
            Everything you need to know about Agent Memory Gateway
          </p>
        </div>

        <div
          className={`bg-white rounded-xl shadow-sm transition-all duration-500 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
          style={{ transitionDelay: '200ms' } as React.CSSProperties}
        >
          <div className="p-6">
            <Accordion items={accordionItems} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;